import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import DashboardScreen from ".";

const RouterDashboard = () => {
  const { path } = useRouteMatch();
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}`}>
        <DashboardScreen />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterDashboard;
